<template>
<div class="reply-wrapper">
  <div class="reply-wrapper-title">
    对话记录
  </div>
  <ul class="reply-container">
    <li
      v-for="dialogue in ticketDialogue" 
      :key="dialogue.id"
      :class="{'user-reply': dialogue.type === 0, 'service-reply': dialogue.type === 1}"
    >
      <span class="icon"><i class="el-icon-service"></i></span>
      <div class="reply-content">
        <p>{{dialogue.note}}</p>
        <span>{{dialogue.createTime | moment}}</span>
      </div>
    </li>
  </ul>
  <div class="reply-action" v-if="replyable">
    <el-input type="textarea" v-model="content"></el-input>
    <el-button size="medium" type="primary" @click="sendReply">发送</el-button>
  </div>
</div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'TicketDialogue',
  props: ['ticket'],
  data() {
    return {
      content: ''
    };
  },
  computed: {
    ...mapState('loginUserTicket', ['ticketDialogue']),
    replyable() {
      return (
        (this.ticket || {}).status !== 1 && (this.ticket || {}).status !== 3
      );
    }
  },
  methods: {
    ...mapActions('loginUserTicket', ['dialogue', 'createDialogueReply']),
    getTicketDialogue() {
      return this.dialogue(this.ticket.id);
    },
    sendReply() {
      if (this.content) {
        this.createDialogueReply({
          workOrderId: this.ticket.id,
          note: this.content
        }).then(() => {
          this.$message({
            message: '发送成功！',
            type: 'success'
          });
          this.content = '';
          this.getTicketDialogue();
        });
      }
    }
  },
  watch: {
    ticket(newVal, oldVal) {
      if (newVal && newVal.id !== oldVal) {
        this.getTicketDialogue();
      }
    }
  },
  created() {
    this.getTicketDialogue();
  }
};
</script>

<style lang="less" scoped>
@import url('~styles/variables.less');

.reply-wrapper {
  display: flex;
  flex-direction: column;
  padding: 0 20px;
  width: 450px;
  border-left: 1px solid @border-color-base;
}
.reply-wrapper-title {
  font-size: 16px;
  text-align: center;
}
.reply-container {
  list-style: none;
  padding: 0;
  flex: 1;
  overflow: auto;
  li {
    display: flex;
    align-items: flex-start;
    &.user-reply {
      flex-direction: row;
      .icon {
        background-color: @background-color-base;
        margin-right: 10px;
      }
    }
    &.service-reply {
      flex-direction: row-reverse;
      .icon {
        background-color: @color-success;
        color: #fff;
        margin-left: 10px;
      }
      .reply-content {
        text-align: right;
        p {
          text-align: left;
        }
      }
    }

    .icon {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 50px;
      height: 50px;
      border-radius: 50px;
      color: @icon-color;
      font-size: 16px;
    }
  }
}
.reply-content {
  max-width: 60%;
  p {
    background-color: @background-color-base;
    padding: 10px 15px;
    border-radius: 4px;
    margin: 0;
  }
  span {
    display: block;
    padding: 0 5px;
    font-size: 12px;
  }
}
.reply-action {
  text-align: right;

  .el-button {
    margin-top: 10px;
  }
}
</style>
